import React, { useCallback, useEffect } from 'react';
import { WarningCircleFillIcon } from '@chegg-ui/horizon-icons';
import { CheckCircleFillIcon } from '@chegg-ui/horizon-icons';
import { colors } from '@chegg-ui/theme';
import { spacing } from '@chegg-ui/theme';
import { abortPolling } from '@chegg/one-auth-sdk';
import { componentViewEventFeedbackModal, interactionTryAgain, interactionTryOtherWay } from "../../../common/rio/rio";
import { FlexWrapperSC, LinkSC, LogoSC, MarginBottomSC, TypographySC } from "../../../common/styles/common.styles";
import { setIsToastOpen } from "../../../store/slices/errorModal";
import { cleanup } from "../../../utils/cleanup";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { changeRoute } from "../../../store/slices/router";
import { FooterSC } from "../FeedbackModals.styles";
import { getNotificationLabels } from "./notification.utils";
export var Notification = function Notification(props) {
  var variant = props.variant;
  var currentRoute = useAppSelector(function (state) {
    return state.router.current_route;
  });
  var dispatch = useAppDispatch();
  var onPushDeclinedRetryCb = useCallback(function () {
    interactionTryAgain(currentRoute);
    cleanup();
  }, [currentRoute]);
  var onLinkClickCb = useCallback(function () {
    interactionTryOtherWay('os push declined navigate link');
    abortPolling();
    dispatch(setIsToastOpen({
      isOpen: false
    }));
    dispatch(changeRoute('/'));
  }, [dispatch]);
  var _getNotificationLabel = getNotificationLabels(variant),
    title = _getNotificationLabel.title,
    _getNotificationLabel2 = _getNotificationLabel.body,
    body = _getNotificationLabel2 === void 0 ? '' : _getNotificationLabel2,
    footerTextPart_1 = _getNotificationLabel.footerTextPart_1,
    footerRetryLink = _getNotificationLabel.footerRetryLink,
    footerTextPart_2 = _getNotificationLabel.footerTextPart_2,
    footerLinkNavigation = _getNotificationLabel.footerLinkNavigation,
    dataTestId = _getNotificationLabel.dataTestId;
  useEffect(function () {
    componentViewEventFeedbackModal(variant, title);
  }, [variant, title]);
  return /*#__PURE__*/React.createElement(FlexWrapperSC, {
    "data-test": "notification_modal"
  }, /*#__PURE__*/React.createElement(LogoSC, null, renderIcon()), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px12
  }, /*#__PURE__*/React.createElement(TypographySC, {
    variant: "h2",
    variantType: "bold"
  }, title)), renderBody(), renderFooter());
  function renderIcon() {
    if (variant === 'success') {
      return /*#__PURE__*/React.createElement(CheckCircleFillIcon, {
        "data-test": "notification_success",
        size: "large",
        color: colors.orange700
      });
    } else {
      return /*#__PURE__*/React.createElement(WarningCircleFillIcon, {
        "data-test": "notification_error",
        size: "large",
        color: colors.red700
      });
    }
  }
  function renderBody() {
    if (variant !== 'os_push_declined') {
      return null;
    }
    return /*#__PURE__*/React.createElement(TypographySC, {
      variant: "body1",
      variantType: "paragraph",
      "data-test": "error_notification_subtitle"
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: body
      }
    }));
  }
  function renderFooter() {
    if (variant === 'success' || variant === 'app_push_declined') {
      return /*#__PURE__*/React.createElement(FooterSC, {
        variant: "body1",
        variantType: "normal",
        "data-test": dataTestId
      }, footerTextPart_1, /*#__PURE__*/React.createElement(LinkSC, {
        hasButtonBehavior: true,
        "data-test": "app_push_declined_retry_link",
        onClick: onPushDeclinedRetryCb
      }, footerRetryLink), footerTextPart_2, /*#__PURE__*/React.createElement(LinkSC, {
        hasButtonBehavior: true,
        "data-test": "os_push_declined_navigate_link",
        onClick: onLinkClickCb
      }, footerLinkNavigation));
    }
    return /*#__PURE__*/React.createElement(FooterSC, {
      variant: "body1",
      variantType: "normal",
      "data-test": dataTestId
    }, /*#__PURE__*/React.createElement(LinkSC, {
      hasButtonBehavior: true,
      "data-test": "os_push_declined_navigate_link",
      onClick: onLinkClickCb
    }, footerLinkNavigation));
  }
};